export class AnalyticsService {
  public static readonly StopArea = 'Hållplatser';
  public static readonly TrafficSituation = 'Trafikinformation';
  public static readonly TravelWithUs = 'Klick på Före, Under, Efter Resan';
  public static readonly Links = 'Klick på länk';
  public static readonly WatchVideo = 'Titta på video';
  public static readonly Accordion = 'Klick på Plusknapp';
  public static readonly CallControlledTraffic = 'Anropsstyrd trafik';
  public static readonly HeaderCategory = 'Header';
  public static readonly MobileMenuCategory = 'Mobilmeny';
  public static readonly InternalLinkAction = 'Klick på intern länk';
  public static readonly ContactUsCategory = 'Klick på Kontakta oss';
  public static readonly TravelPlannerCategory = 'Reseplanering (VT)';
  public static readonly TravelPlannerCategoryFilters = 'Reseplanering (VT) - Filter';
  public static readonly JourneySearchCategory = 'Sök resa (startsida)';
  public static readonly FindTicketCategory = 'Hitta biljett';
  public static readonly NextDepartureCategory = 'Nästa tur (startsida)';
  public static readonly FindTicket = 'Hitta biljett';
  public static readonly QuestionsAndOpinions = 'Frågor och synpunkter';
  public static readonly Reclamation = 'Reklamation';
  public static readonly Refund = 'Återköp';
  public static readonly TrafficSituations = 'Trafikinformation';
  public static readonly Timetables = 'Tidtabeller';
  public static readonly LostAndFound = 'Hittegods';
  public static readonly MobileMenu = 'Mobilmeny';
  public static readonly CertificateCard = 'Intygskort';
  public static readonly SiteSearchCategory: string = 'Sök';
  public static readonly ErrorAction: string = 'Fel';
  public static readonly DelayCompensationCategory: string = 'Förseningsersättning';
  public static readonly DelayCompensationOresundstagCategory: string = 'Förseningsersättning Öresundståg';
  public static readonly DelayCompensationTransportWarrantyCategory: string = 'Förseningsersättning Taxi/Egen bil';
  public static readonly ZeroResultsAction: string = 'Nollresultat';
  public static readonly InternalErrorLabel = 'Internt fel';
  public static readonly AttachFileAction = 'Bifoga fil';
  public static readonly LinksCategory = 'Klick på länk';
  public static readonly PhoneNumberAction = 'Klick på telefonnummer';
  public static readonly EmailAddressAction = 'Klick på e-postadress';
  public static readonly ExternalLinkAction = 'Klick på extern länk';
  public static readonly TicketInspectionSurchargeAppeal = 'Överklaga tilläggsavgift';
  public static readonly TrafficInformationOverview = 'Störningsblock startsidan';
  public static readonly TripLegSelector = 'Delreseväljare';
  public static readonly PaEgnaBenAdmin = 'På egna ben: Admin';
  public static readonly PaEgnaBenTeacher = 'På egna ben: Pedagog';
  public static readonly PaEgnaBenPublic = 'På egna ben: Publikt';
  public static readonly PriceCalculator = 'Priskalkylator';
  public static readonly TravelAssistanceCard = 'Reshjälpskort';
  public static readonly StralkastarenRegistration = 'Strålkastaren: Registrering';
  public static readonly StralkastarenUnregistration = 'Strålkastaren: Avregistrering';
  public static readonly Forms = 'Redaktörsformulär';
  public static readonly MyStopAreas = 'Mina hållplatser';
  public static readonly VehiclePositionsMap = 'Fordonspositionskarta';

  public static addEvent(category: string, action: string, label?: string) {
    try {
      if (window._paq) {
        window._paq.push(['trackEvent', category, action, label ?? '']);
      }
    } catch {
      /* empty */
    }
  }
}
